import { ArrowRight, Bot, Building2, Sparkles } from 'lucide-react'
import { Link } from 'react-router-dom'

const actions = [
  {
    title: 'Configurar novo cliente',
    description: 'Crie o cliente, o primeiro agente e o canal de atendimento em um fluxo guiado.',
    to: '/onboarding?flow=client',
    icon: Building2,
    accent: '#AD34FE',
    background: 'linear-gradient(135deg, rgba(173,52,254,0.28), rgba(123,31,212,0.08))',
  },
  {
    title: 'Criar novo agente',
    description: 'Escolha um cliente e configure um agente com o próprio canal de atendimento.',
    to: '/onboarding?flow=agent',
    icon: Bot,
    accent: '#34ADFE',
    background: 'linear-gradient(135deg, rgba(52,173,254,0.22), rgba(173,52,254,0.07))',
  },
]

export default function SetupActions() {
  return (
    <section aria-labelledby="quick-actions-title">
      <div className="mb-3 flex items-end justify-between gap-4">
        <div>
          <div className="flex items-center gap-2">
            <Sparkles size={14} style={{ color: 'var(--dash-primary)' }} />
            <h2 id="quick-actions-title" className="text-sm font-semibold" style={{ color: 'var(--dash-text)' }}>
              Comece uma configuração
            </h2>
          </div>
          <p className="mt-1 text-xs" style={{ color: 'var(--dash-text-muted)' }}>
            Você pode sair a qualquer momento e continuar de onde parou.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {actions.map((action) => {
          const Icon = action.icon
          return (
            <Link
              key={action.to}
              to={action.to}
              className="group relative overflow-hidden rounded-2xl border p-6 transition-all duration-200 hover:-translate-y-0.5"
              style={{
                background: action.background,
                borderColor: `${action.accent}55`,
                boxShadow: `0 12px 30px -18px ${action.accent}80`,
              }}
            >
              <div className="absolute -right-5 -top-8 h-32 w-32 rounded-full blur-3xl" style={{ background: action.accent, opacity: 0.18 }} />
              <div className="relative flex min-h-32 flex-col justify-between gap-5">
                <div className="flex items-start gap-4">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl" style={{ background: `${action.accent}24`, border: `1px solid ${action.accent}55`, color: action.accent }}>
                    <Icon size={23} strokeWidth={2.1} />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold tracking-tight" style={{ color: 'var(--dash-text)' }}>
                      {action.title}
                    </h3>
                    <p className="mt-1.5 max-w-md text-xs leading-relaxed" style={{ color: 'var(--dash-text-muted)' }}>
                      {action.description}
                    </p>
                  </div>
                </div>
                <span className="inline-flex items-center gap-2 text-xs font-semibold" style={{ color: action.accent }}>
                  Abrir fluxo guiado
                  <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          )
        })}
      </div>
    </section>
  )
}
